import React from "react";
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="section" style={{ background: 'var(--gradient-primary)', color: 'white', paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="container text-center">
          <h1 style={{ color: 'white', fontSize: '3rem', marginBottom: '1.5rem' }}>
            Why Choose <span style={{ color: 'var(--primary-green)' }}>VissdaTech</span>?
          </h1>
          <p style={{
            fontSize: '1.25rem',
            maxWidth: '800px',
            margin: '0 auto',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.7
          }}>
            Discover what sets us apart in the competitive SaaS landscape and why businesses trust us with their digital transformation.
          </p>
        </div>
      </section>

      {/* Main Features */}
      <section className="section">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Our Competitive Advantages</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              What makes VissdaTech the preferred choice for businesses seeking reliable SaaS solutions
            </p>
          </div>

          <div className="grid grid-2" style={{ gap: '3rem' }}>
            {features.map((feature, index) => (
              <div key={index} className="card" style={{
                background: index % 2 === 0 ? 'var(--white)' : 'var(--gray-50)',
                padding: '3rem',
                border: index % 2 === 0 ? '1px solid var(--gray-200)' : 'none',
                display: 'flex',
                gap: '2rem',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  fontSize: '4rem',
                  background: 'var(--gradient-accent)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  flexShrink: 0
                }}>
                  {feature.icon}
                </div>
                <div>
                  <h3 style={{ color: 'var(--primary-green)', marginBottom: '1rem', fontSize: '1.5rem' }}>
                    {feature.title}
                  </h3>
                  <p style={{ color: 'var(--gray-600)', marginBottom: '1.5rem', lineHeight: 1.7 }}>
                    {feature.description}
                  </p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {feature.points.map((point, i) => (
                      <li key={i} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem',
                        marginBottom: '0.75rem',
                        color: 'var(--gray-700)'
                      }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--primary-green)" strokeWidth="2">
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technical Excellence */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Technical Excellence</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              Built on modern architecture with industry-leading technologies
            </p>
          </div>

          <div className="grid grid-3">
            {technicalFeatures.map((tech, index) => (
              <div key={index} className="card text-center">
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '1.5rem',
                  background: 'var(--gradient-primary)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  {tech.icon}
                </div>
                <h3 style={{ marginBottom: '1rem', color: 'var(--primary-green)' }}>{tech.title}</h3>
                <p style={{ color: 'var(--gray-600)', marginBottom: '1.5rem' }}>{tech.description}</p>
                <div style={{
                  background: 'var(--primary-green)',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: 'var(--radius-md)',
                  fontSize: '0.9rem',
                  fontWeight: 600
                }}>
                  {tech.metric}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

     

      {/* CTA Section */}
      <section className="section" style={{ background: 'var(--gradient-hero)', color: 'white' }}>
        <div className="container text-center">
          <h2 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '1rem' }}>
            Experience the VissdaTech Difference
          </h2>
          <p style={{
            fontSize: '1.25rem',
            marginBottom: '2rem',
            color: 'rgba(255, 255, 255, 0.9)',
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Join the growing number of businesses that have chosen VissdaTech for their digital transformation journey.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn btn-accent">
              Start Your Free Trial
            </Link>
            <Link to="/solutions" className="btn btn-outline" style={{ color: 'white', borderColor: 'white' }}>
              Explore Solutions
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

const features = [
  {
    title: "Unmatched Expertise",
    icon: "🎯",
    description: "Our team brings decades of combined experience in enterprise software development, cloud architecture, and business process optimization. We understand the unique challenges businesses face and have the expertise to solve them.",
    points: [
      "15+ years average team experience",
      "Industry-certified developers and architects",
      "Proven track record across multiple sectors",
      "Continuous learning and technology adoption"
    ]
  },
  {
    title: "Enterprise-Grade Security",
    icon: "🔒",
    description: "Security isn't an afterthought—it's built into every layer of our solutions. We implement bank-level security protocols and maintain the highest standards of data protection to keep your business safe.",
    points: [
      "SOC 2 Type II compliance",
      "End-to-end encryption for all data",
      "Regular security audits and penetration testing",
      "GDPR and industry-specific compliance"
    ]
  },
  {
    title: "Unparalleled Scalability",
    icon: "📈",
    description: "Built on modern cloud architecture, our solutions grow seamlessly with your business. From startup to enterprise scale, our systems maintain optimal performance without costly migrations or downtime.",
    points: [
      "Auto-scaling cloud infrastructure",
      "Load balancing for high availability",
      "Global content delivery network",
      "99.9% uptime guarantee with SLA"
    ]
  },
  {
    title: "Exceptional Support",
    icon: "🤝",
    description: "We don't just provide software—we provide partnership. Our dedicated support team is available 24/7 to ensure your success, with personalized assistance and proactive monitoring.",
    points: [
      "24/7 technical support coverage",
      "Dedicated customer success manager",
      "Comprehensive training and onboarding",
      "Proactive system monitoring and alerts"
    ]
  },
  {
    title: "Complete Customization",
    icon: "🔧",
    description: "Every business is unique, and your software should be too. Our solutions are highly customizable, allowing you to tailor functionality, workflows, and interfaces to match your specific needs.",
    points: [
      "Flexible workflow configuration",
      "Custom field and form creation",
      "White-label branding options",
      "API access for third-party integrations"
    ]
  },
  {
    title: "Transparent Pricing",
    icon: "💰",
    description: "No hidden fees, no surprise charges. Our transparent pricing model ensures you know exactly what you're paying for, with flexible plans that scale with your usage and growth.",
    points: [
      "Clear, upfront pricing structure",
      "No hidden fees or surprise charges",
      "Flexible payment and billing options",
      "Volume discounts for growing businesses"
    ]
  }
];

const technicalFeatures = [
  {
    title: "Cloud-Native Architecture",
    icon: "☁️",
    description: "Built on modern microservices architecture for maximum reliability and performance.",
    metric: "99.9% Uptime"
  },
  {
    title: "Lightning Performance",
    icon: "⚡",
    description: "Optimized for speed with global CDN and intelligent caching strategies.",
    metric: "<200ms Response"
  },
  {
    title: "Advanced Analytics",
    icon: "📊",
    description: "Real-time data processing and AI-powered insights for better decision making.",
    metric: "Real-time Data"
  }
];

const testimonials = [
  {
    quote: "VissdaTech transformed our operations completely. The CRM system increased our sales efficiency by 40% in just 3 months.",
    name: "Sarah Johnson",
    role: "CEO",
    company: "TechFlow Solutions"
  },
  {
    quote: "The inventory management system saved us thousands in carrying costs. The real-time tracking is a game-changer for our business.",
    name: "Michael Chen",
    role: "Operations Director",
    company: "Global Supply Co"
  },
  {
    quote: "Outstanding support team and incredibly reliable software. We've had zero downtime since implementation 18 months ago.",
    name: "Emily Rodriguez",
    role: "IT Manager",
    company: "MedCore Industries"
  }
];

const comparisonData = [
  { feature: "24/7 Support", vissdatech: "✓", competitorA: "Business hours only", competitorB: "Email only" },
  { feature: "Custom Development", vissdatech: "✓", competitorA: "Limited", competitorB: "✗" },
  { feature: "Data Migration", vissdatech: "Free", competitorA: "Additional cost", competitorB: "Additional cost" },
  { feature: "API Access", vissdatech: "Full access", competitorA: "Limited", competitorB: "Premium only" },
  { feature: "Training Included", vissdatech: "✓", competitorA: "Additional cost", competitorB: "✗" },
  { feature: "Mobile Apps", vissdatech: "iOS & Android", competitorA: "Web only", competitorB: "iOS only" },
  { feature: "Backup Frequency", vissdatech: "Real-time", competitorA: "Daily", competitorB: "Weekly" }
];

export default WhyChooseUs;